// Import React Components
import React, {useEffect, useState} from 'react';

// Import Data
import {SIDE_NAV_MANAGEMENT} from "../../../services/MockData";

// Import Material UI Elements
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

// Import State Management
import {useRecoilState} from 'recoil';
import {activeSideBarMenu} from '../../../recoil-store/recoil-state';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

function UserManagement(props) {
    const [userManagementMenu, setUserManagementMenu] = useState([]);
    const [selected, setSelected] = useState(0);
    const [asmTemp, setAsmTemp] = useState({});
    const navigate = useNavigate();
    const classes = useStyles();
    const {t} = useTranslation();

    useEffect(() => {
        if (props.asm) setAsmTemp(JSON.parse(JSON.stringify(props.asm)));
        const menus = SIDE_NAV_MANAGEMENT.subItems.find(x => x.name === 'user-management');
        setUserManagementMenu(menus);
        if (props.asm?.thirdChild && props.asm?.child === menus.order) setSelected(props.asm.thirdChild);
        else setSelected(SIDE_NAV_MANAGEMENT.subItems.find(x => x.name === 'user-management').thirdLevelItems[0].order);
    }, []);

    const navigateUser = (to, thirdOrder, childOrder) => {
        if (to) {
            asmTemp.thirdChild = thirdOrder;
            asmTemp.child = childOrder;
            setAsmTemp(asmTemp);
            setSelected(thirdOrder);
            navigate(to);
        }
    }

    return (
        <Grid container className={classes.root} spacing={2}>
            <Grid item xs={12} sm={3} md={2}>
                <Grid key={0} item>
                    <div className="third-level-menu">
                        <h5 className="tlm-header">Menu</h5>
                        {userManagementMenu.thirdLevelItems?.map((item, index) => {
                            return (
                                <div key={index} className="third-level-menu-item-row">
                                    <div
                                        id={`${item.order} ${selected} ${asmTemp?.thirdChild}`}
                                        className={`third-level-menu-item ${selected === item.order || asmTemp?.thirdChild === item.order ? "active-menu" : ""}`}
                                        onClick={() => navigateUser(item.to, item.order, userManagementMenu.order)}>
                                        {t(item.label)}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={9} md={10}>
                <Grid key={1}>
                    {props.directTo}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default UserManagement;
